var _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeck11(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: 0,
    y: 0,
    width: 1004,
    height: 238,
    viewBox: "0, 0, 1004, 238",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Background"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1004,
    height: 238,
    fill: "#000000",
    fillOpacity: 0
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Background",
    display: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1004,0 L1004,238 L0,238 z",
    fill: "#FFFFFF"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "FPSO_FRAMING_LAYOUT"
  }, /*#__PURE__*/React.createElement("g", {
    id: "T/Deck/zijdong-Copy-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M238.932,28.262 L127.084,28.262 L127.084,11.321 L222.31,2.174 L222.31,16.621 C221.097,18.644 223.292,21.09 228.898,23.959 C234.503,26.828 237.848,28.262 238.932,28.262 z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.932,28.262 L127.084,28.262 L127.084,11.321 L222.31,2.174 L222.31,16.621 C221.097,18.644 223.292,21.09 228.898,23.959 C234.503,26.828 237.848,28.262 238.932,28.262 z",
    fillOpacity: 0,
    stroke: "#979797",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M222.31,16.621 L127.084,28.262 L127.084,22.441 L212.68,15.218 L212.68,8.532 L127.084,15.218",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.31,16.621 L127.084,28.262 L127.084,22.441 L212.68,15.218 L212.68,8.532 L127.084,15.218",
    fillOpacity: 0,
    stroke: "#979797",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M200.393,25.778 C200.393,26.867 201.275,27.75 202.364,27.75 C203.454,27.75 204.336,26.867 204.336,25.778 C204.336,24.69 203.454,23.807 202.364,23.807 C201.275,23.807 200.393,24.69 200.393,25.778 z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.393,25.778 C200.393,26.867 201.275,27.75 202.364,27.75 C203.454,27.75 204.336,26.867 204.336,25.778 C204.336,24.69 203.454,23.807 202.364,23.807 C201.275,23.807 200.393,24.69 200.393,25.778 z",
    fillOpacity: 0,
    stroke: "#979797",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval-Copy-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M190.512,13.585 C190.647,15.123 192.003,16.261 193.541,16.127 C195.079,15.992 196.217,14.636 196.083,13.098 C195.948,11.56 194.592,10.423 193.054,10.557 C191.516,10.692 190.378,12.048 190.512,13.585 z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.512,13.585 C190.647,15.123 192.003,16.261 193.541,16.127 C195.079,15.992 196.217,14.636 196.083,13.098 C195.948,11.56 194.592,10.423 193.054,10.557 C191.516,10.692 190.378,12.048 190.512,13.585 z",
    fillOpacity: 0,
    stroke: "#979797",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval-Copy-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M179.568,14.543 C179.702,16.081 181.059,17.219 182.597,17.084 C184.135,16.949 185.273,15.594 185.138,14.056 C185.004,12.518 183.648,11.38 182.11,11.515 C180.571,11.649 179.433,13.005 179.568,14.543 z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.568,14.543 C179.702,16.081 181.059,17.219 182.597,17.084 C184.135,16.949 185.273,15.594 185.138,14.056 C185.004,12.518 183.648,11.38 182.11,11.515 C180.571,11.649 179.433,13.005 179.568,14.543 z",
    fillOpacity: 0,
    stroke: "#979797",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval-Copy-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168.624,15.5 C168.758,17.038 170.114,18.176 171.652,18.042 C173.191,17.907 174.329,16.551 174.194,15.013 C174.059,13.475 172.703,12.338 171.165,12.472 C169.627,12.607 168.489,13.963 168.624,15.5 z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.624,15.5 C168.758,17.038 170.114,18.176 171.652,18.042 C173.191,17.907 174.329,16.551 174.194,15.013 C174.059,13.475 172.703,12.338 171.165,12.472 C169.627,12.607 168.489,13.963 168.624,15.5 z",
    fillOpacity: 0,
    stroke: "#979797",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval-Copy-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157.679,16.458 C157.814,17.996 159.17,19.134 160.708,18.999 C162.246,18.864 163.384,17.509 163.25,15.971 C163.115,14.433 161.759,13.295 160.221,13.43 C158.683,13.564 157.545,14.92 157.679,16.458 z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.679,16.458 C157.814,17.996 159.17,19.134 160.708,18.999 C162.246,18.864 163.384,17.509 163.25,15.971 C163.115,14.433 161.759,13.295 160.221,13.43 C158.683,13.564 157.545,14.92 157.679,16.458 z",
    fillOpacity: 0,
    stroke: "#979797",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval-Copy-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M146.735,17.415 C146.869,18.953 148.226,20.091 149.764,19.957 C151.302,19.822 152.44,18.466 152.305,16.928 C152.171,15.39 150.815,14.253 149.276,14.387 C147.738,14.522 146.6,15.878 146.735,17.415 z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.735,17.415 C146.869,18.953 148.226,20.091 149.764,19.957 C151.302,19.822 152.44,18.466 152.305,16.928 C152.171,15.39 150.815,14.253 149.276,14.387 C147.738,14.522 146.6,15.878 146.735,17.415 z",
    fillOpacity: 0,
    stroke: "#979797",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval-Copy-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135.791,18.373 C135.925,19.911 137.281,21.049 138.819,20.914 C140.358,20.779 141.496,19.424 141.361,17.886 C141.226,16.348 139.87,15.21 138.332,15.345 C136.794,15.479 135.656,16.835 135.791,18.373 z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.791,18.373 C135.925,19.911 137.281,21.049 138.819,20.914 C140.358,20.779 141.496,19.424 141.361,17.886 C141.226,16.348 139.87,15.21 138.332,15.345 C136.794,15.479 135.656,16.835 135.791,18.373 z",
    fillOpacity: 0,
    stroke: "#979797",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-Copy"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0.923,172.953 L47.105,157.054 L62.544,201.883 L16.361,217.783 L0.923,172.953 z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.923,172.953 L47.105,157.054 L62.544,201.883 L16.361,217.783 L0.923,172.953 z",
    fillOpacity: 0,
    stroke: "#979797",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path-3-Copy-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.681,180.521 C12.586,175.52 17.894,172.09 24.606,170.233 C31.318,168.377 36.821,168.377 41.116,170.233 C37.436,174.644 33.449,177.665 29.154,179.295 C24.859,180.926 18.034,181.335 8.681,180.521 z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.681,180.521 C12.586,175.52 17.894,172.09 24.606,170.233 C31.318,168.377 36.821,168.377 41.116,170.233 C37.436,174.644 33.449,177.665 29.154,179.295 C24.859,180.926 18.034,181.335 8.681,180.521 z",
    fillOpacity: 0,
    stroke: "#979797",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path-3-Copy-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.377,193.336 C18.282,188.335 23.59,184.905 30.303,183.049 C37.015,181.192 42.518,181.192 46.812,183.049 C43.133,187.459 39.146,190.48 34.85,192.11 C30.555,193.741 23.731,194.15 14.377,193.336 z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.377,193.336 C18.282,188.335 23.59,184.905 30.303,183.049 C37.015,181.192 42.518,181.192 46.812,183.049 C43.133,187.459 39.146,190.48 34.85,192.11 C30.555,193.741 23.731,194.15 14.377,193.336 z",
    fillOpacity: 0,
    stroke: "#979797",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path-3-Copy-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.074,206.151 C23.978,201.15 29.287,197.72 35.999,195.864 C42.711,194.007 48.214,194.007 52.508,195.864 C48.829,200.274 44.842,203.295 40.547,204.925 C36.251,206.556 29.427,206.965 20.074,206.151 z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.074,206.151 C23.978,201.15 29.287,197.72 35.999,195.864 C42.711,194.007 48.214,194.007 52.508,195.864 C48.829,200.274 44.842,203.295 40.547,204.925 C36.251,206.556 29.427,206.965 20.074,206.151 z",
    fillOpacity: 0,
    stroke: "#979797",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "T/Deck/zijdong"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M826.409,29.262 L938.256,29.262 L938.256,12.321 L843.031,3.174 L843.031,17.621 C844.244,19.644 842.048,22.09 836.443,24.959 C830.838,27.828 827.493,29.262 826.409,29.262 z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M826.409,29.262 L938.256,29.262 L938.256,12.321 L843.031,3.174 L843.031,17.621 C844.244,19.644 842.048,22.09 836.443,24.959 C830.838,27.828 827.493,29.262 826.409,29.262 z",
    fillOpacity: 0,
    stroke: "#979797",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M843.031,17.621 L938.256,29.262 L938.256,23.441 L852.661,16.218 L852.661,9.532 L938.256,16.218",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M843.031,17.621 L938.256,29.262 L938.256,23.441 L852.661,16.218 L852.661,9.532 L938.256,16.218",
    fillOpacity: 0,
    stroke: "#979797",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M864.948,26.778 C864.948,27.867 864.065,28.75 862.976,28.75 C861.887,28.75 861.004,27.867 861.004,26.778 C861.004,25.69 861.887,24.807 862.976,24.807 C864.065,24.807 864.948,25.69 864.948,26.778 z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M864.948,26.778 C864.948,27.867 864.065,28.75 862.976,28.75 C861.887,28.75 861.004,27.867 861.004,26.778 C861.004,25.69 861.887,24.807 862.976,24.807 C864.065,24.807 864.948,25.69 864.948,26.778 z",
    fillOpacity: 0,
    stroke: "#979797",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval-Copy-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M874.829,14.585 C874.694,16.123 873.338,17.261 871.8,17.127 C870.262,16.992 869.124,15.636 869.258,14.098 C869.393,12.56 870.749,11.423 872.287,11.557 C873.825,11.692 874.963,13.048 874.829,14.585 z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M874.829,14.585 C874.694,16.123 873.338,17.261 871.8,17.127 C870.262,16.992 869.124,15.636 869.258,14.098 C869.393,12.56 870.749,11.423 872.287,11.557 C873.825,11.692 874.963,13.048 874.829,14.585 z",
    fillOpacity: 0,
    stroke: "#979797",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval-Copy-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M885.773,15.543 C885.638,17.081 884.282,18.219 882.744,18.084 C881.206,17.949 880.068,16.594 880.203,15.056 C880.337,13.518 881.693,12.38 883.231,12.515 C884.77,12.649 885.908,14.005 885.773,15.543 z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M885.773,15.543 C885.638,17.081 884.282,18.219 882.744,18.084 C881.206,17.949 880.068,16.594 880.203,15.056 C880.337,13.518 881.693,12.38 883.231,12.515 C884.77,12.649 885.908,14.005 885.773,15.543 z",
    fillOpacity: 0,
    stroke: "#979797",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval-Copy-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M896.717,16.5 C896.583,18.038 895.227,19.176 893.688,19.042 C892.15,18.907 891.012,17.551 891.147,16.013 C891.281,14.475 892.637,13.338 894.176,13.472 C895.714,13.607 896.852,14.963 896.717,16.5 z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M896.717,16.5 C896.583,18.038 895.227,19.176 893.688,19.042 C892.15,18.907 891.012,17.551 891.147,16.013 C891.281,14.475 892.637,13.338 894.176,13.472 C895.714,13.607 896.852,14.963 896.717,16.5 z",
    fillOpacity: 0,
    stroke: "#979797",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval-Copy-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M907.662,17.458 C907.527,18.996 906.171,20.134 904.633,19.999 C903.095,19.864 901.957,18.509 902.091,16.971 C902.226,15.433 903.582,14.295 905.12,14.43 C906.658,14.564 907.796,15.92 907.662,17.458 z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M907.662,17.458 C907.527,18.996 906.171,20.134 904.633,19.999 C903.095,19.864 901.957,18.509 902.091,16.971 C902.226,15.433 903.582,14.295 905.12,14.43 C906.658,14.564 907.796,15.92 907.662,17.458 z",
    fillOpacity: 0,
    stroke: "#979797",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval-Copy-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M918.606,18.415 C918.471,19.953 917.115,21.091 915.577,20.957 C914.039,20.822 912.901,19.466 913.036,17.928 C913.17,16.39 914.526,15.253 916.064,15.387 C917.603,15.522 918.74,16.878 918.606,18.415 z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M918.606,18.415 C918.471,19.953 917.115,21.091 915.577,20.957 C914.039,20.822 912.901,19.466 913.036,17.928 C913.17,16.39 914.526,15.253 916.064,15.387 C917.603,15.522 918.74,16.878 918.606,18.415 z",
    fillOpacity: 0,
    stroke: "#979797",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval-Copy-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M929.55,19.373 C929.416,20.911 928.06,22.049 926.521,21.914 C924.983,21.779 923.845,20.424 923.98,18.886 C924.114,17.348 925.47,16.21 927.009,16.345 C928.547,16.479 929.685,17.835 929.55,19.373 z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M929.55,19.373 C929.416,20.911 928.06,22.049 926.521,21.914 C924.983,21.779 923.845,20.424 923.98,18.886 C924.114,17.348 925.47,16.21 927.009,16.345 C928.547,16.479 929.685,17.835 929.55,19.373 z",
    fillOpacity: 0,
    stroke: "#979797",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "T/Deck/zijdong-Copy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M831.907,211.086 L943.754,211.086 L943.754,228.028 L848.529,237.174 L848.529,222.728 C849.742,220.705 847.546,218.259 841.941,215.39 C836.336,212.521 832.991,211.086 831.907,211.086 z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M831.907,211.086 L943.754,211.086 L943.754,228.028 L848.529,237.174 L848.529,222.728 C849.742,220.705 847.546,218.259 841.941,215.39 C836.336,212.521 832.991,211.086 831.907,211.086 z",
    fillOpacity: 0,
    stroke: "#979797",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M848.529,222.728 L943.754,211.086 L943.754,216.907 L858.159,224.13 L858.159,230.817 L943.754,224.13",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M848.529,222.728 L943.754,211.086 L943.754,216.907 L858.159,224.13 L858.159,230.817 L943.754,224.13",
    fillOpacity: 0,
    stroke: "#979797",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M870.446,213.57 C870.446,212.481 869.563,211.599 868.474,211.599 C867.385,211.599 866.502,212.481 866.502,213.57 C866.502,214.659 867.385,215.542 868.474,215.542 C869.563,215.542 870.446,214.659 870.446,213.57 z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M870.446,213.57 C870.446,212.481 869.563,211.599 868.474,211.599 C867.385,211.599 866.502,212.481 866.502,213.57 C866.502,214.659 867.385,215.542 868.474,215.542 C869.563,215.542 870.446,214.659 870.446,213.57 z",
    fillOpacity: 0,
    stroke: "#979797",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval-Copy-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M880.327,225.763 C880.192,224.225 878.836,223.087 877.298,223.222 C875.76,223.357 874.622,224.712 874.756,226.25 C874.891,227.788 876.247,228.926 877.785,228.791 C879.323,228.657 880.461,227.301 880.327,225.763 z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M880.327,225.763 C880.192,224.225 878.836,223.087 877.298,223.222 C875.76,223.357 874.622,224.712 874.756,226.25 C874.891,227.788 876.247,228.926 877.785,228.791 C879.323,228.657 880.461,227.301 880.327,225.763 z",
    fillOpacity: 0,
    stroke: "#979797",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval-Copy-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M891.271,224.806 C891.136,223.268 889.78,222.13 888.242,222.265 C886.704,222.399 885.566,223.755 885.701,225.293 C885.835,226.831 887.191,227.969 888.729,227.834 C890.268,227.699 891.406,226.344 891.271,224.806 z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M891.271,224.806 C891.136,223.268 889.78,222.13 888.242,222.265 C886.704,222.399 885.566,223.755 885.701,225.293 C885.835,226.831 887.191,227.969 888.729,227.834 C890.268,227.699 891.406,226.344 891.271,224.806 z",
    fillOpacity: 0,
    stroke: "#979797",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval-Copy-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M902.215,223.848 C902.081,222.31 900.725,221.172 899.186,221.307 C897.648,221.442 896.51,222.797 896.645,224.335 C896.779,225.873 898.135,227.011 899.674,226.876 C901.212,226.742 902.35,225.386 902.215,223.848 z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M902.215,223.848 C902.081,222.31 900.725,221.172 899.186,221.307 C897.648,221.442 896.51,222.797 896.645,224.335 C896.779,225.873 898.135,227.011 899.674,226.876 C901.212,226.742 902.35,225.386 902.215,223.848 z",
    fillOpacity: 0,
    stroke: "#979797",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval-Copy-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M913.16,222.891 C913.025,221.353 911.669,220.215 910.131,220.35 C908.593,220.484 907.455,221.84 907.589,223.378 C907.724,224.916 909.08,226.054 910.618,225.919 C912.156,225.784 913.294,224.428 913.16,222.891 z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M913.16,222.891 C913.025,221.353 911.669,220.215 910.131,220.35 C908.593,220.484 907.455,221.84 907.589,223.378 C907.724,224.916 909.08,226.054 910.618,225.919 C912.156,225.784 913.294,224.428 913.16,222.891 z",
    fillOpacity: 0,
    stroke: "#979797",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval-Copy-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M924.104,221.933 C923.969,220.395 922.613,219.257 921.075,219.392 C919.537,219.527 918.399,220.882 918.534,222.42 C918.668,223.958 920.024,225.096 921.562,224.961 C923.101,224.827 924.238,223.471 924.104,221.933 z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M924.104,221.933 C923.969,220.395 922.613,219.257 921.075,219.392 C919.537,219.527 918.399,220.882 918.534,222.42 C918.668,223.958 920.024,225.096 921.562,224.961 C923.101,224.827 924.238,223.471 924.104,221.933 z",
    fillOpacity: 0,
    stroke: "#979797",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval-Copy-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M935.048,220.976 C934.914,219.438 933.558,218.3 932.019,218.434 C930.481,218.569 929.343,219.925 929.478,221.463 C929.612,223.001 930.968,224.139 932.507,224.004 C934.045,223.869 935.183,222.513 935.048,220.976 z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M935.048,220.976 C934.914,219.438 933.558,218.3 932.019,218.434 C930.481,218.569 929.343,219.925 929.478,221.463 C929.612,223.001 930.968,224.139 932.507,224.004 C934.045,223.869 935.183,222.513 935.048,220.976 z",
    fillOpacity: 0,
    stroke: "#979797",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "T/Deck/zijdong-Copy-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M238.932,210.388 L127.084,210.388 L127.084,227.329 L222.31,236.476 L222.31,222.029 C221.097,220.006 223.292,217.56 228.898,214.691 C234.503,211.822 237.848,210.388 238.932,210.388 z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.932,210.388 L127.084,210.388 L127.084,227.329 L222.31,236.476 L222.31,222.029 C221.097,220.006 223.292,217.56 228.898,214.691 C234.503,211.822 237.848,210.388 238.932,210.388 z",
    fillOpacity: 0,
    stroke: "#979797",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M222.31,222.029 L127.084,210.388 L127.084,216.208 L212.68,223.432 L212.68,230.118 L127.084,223.432",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.31,222.029 L127.084,210.388 L127.084,216.208 L212.68,223.432 L212.68,230.118 L127.084,223.432",
    fillOpacity: 0,
    stroke: "#979797",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M200.393,212.871 C200.393,211.783 201.275,210.9 202.364,210.9 C203.454,210.9 204.336,211.783 204.336,212.871 C204.336,213.96 203.454,214.843 202.364,214.843 C201.275,214.843 200.393,213.96 200.393,212.871 z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.393,212.871 C200.393,211.783 201.275,210.9 202.364,210.9 C203.454,210.9 204.336,211.783 204.336,212.871 C204.336,213.96 203.454,214.843 202.364,214.843 C201.275,214.843 200.393,213.96 200.393,212.871 z",
    fillOpacity: 0,
    stroke: "#979797",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval-Copy-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M190.512,225.064 C190.647,223.526 192.003,222.389 193.541,222.523 C195.079,222.658 196.217,224.014 196.083,225.552 C195.948,227.09 194.592,228.227 193.054,228.093 C191.516,227.958 190.378,226.602 190.512,225.064 z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.512,225.064 C190.647,223.526 192.003,222.389 193.541,222.523 C195.079,222.658 196.217,224.014 196.083,225.552 C195.948,227.09 194.592,228.227 193.054,228.093 C191.516,227.958 190.378,226.602 190.512,225.064 z",
    fillOpacity: 0,
    stroke: "#979797",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval-Copy-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M179.568,224.107 C179.702,222.569 181.059,221.431 182.597,221.566 C184.135,221.7 185.273,223.056 185.138,224.594 C185.004,226.132 183.648,227.27 182.11,227.135 C180.571,227.001 179.433,225.645 179.568,224.107 z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.568,224.107 C179.702,222.569 181.059,221.431 182.597,221.566 C184.135,221.7 185.273,223.056 185.138,224.594 C185.004,226.132 183.648,227.27 182.11,227.135 C180.571,227.001 179.433,225.645 179.568,224.107 z",
    fillOpacity: 0,
    stroke: "#979797",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval-Copy-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168.624,223.149 C168.758,221.611 170.114,220.474 171.652,220.608 C173.191,220.743 174.329,222.099 174.194,223.637 C174.059,225.175 172.703,226.312 171.165,226.178 C169.627,226.043 168.489,224.687 168.624,223.149 z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.624,223.149 C168.758,221.611 170.114,220.474 171.652,220.608 C173.191,220.743 174.329,222.099 174.194,223.637 C174.059,225.175 172.703,226.312 171.165,226.178 C169.627,226.043 168.489,224.687 168.624,223.149 z",
    fillOpacity: 0,
    stroke: "#979797",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval-Copy-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157.679,222.192 C157.814,220.654 159.17,219.516 160.708,219.651 C162.246,219.785 163.384,221.141 163.25,222.679 C163.115,224.217 161.759,225.355 160.221,225.22 C158.683,225.086 157.545,223.73 157.679,222.192 z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.679,222.192 C157.814,220.654 159.17,219.516 160.708,219.651 C162.246,219.785 163.384,221.141 163.25,222.679 C163.115,224.217 161.759,225.355 160.221,225.22 C158.683,225.086 157.545,223.73 157.679,222.192 z",
    fillOpacity: 0,
    stroke: "#979797",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval-Copy-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M146.735,221.234 C146.869,219.696 148.226,218.559 149.764,218.693 C151.302,218.828 152.44,220.184 152.305,221.722 C152.171,223.26 150.815,224.397 149.276,224.263 C147.738,224.128 146.6,222.772 146.735,221.234 z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.735,221.234 C146.869,219.696 148.226,218.559 149.764,218.693 C151.302,218.828 152.44,220.184 152.305,221.722 C152.171,223.26 150.815,224.397 149.276,224.263 C147.738,224.128 146.6,222.772 146.735,221.234 z",
    fillOpacity: 0,
    stroke: "#979797",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval-Copy-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135.791,220.277 C135.925,218.739 137.281,217.601 138.819,217.736 C140.358,217.87 141.496,219.226 141.361,220.764 C141.226,222.302 139.87,223.44 138.332,223.305 C136.794,223.171 135.656,221.815 135.791,220.277 z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.791,220.277 C135.925,218.739 137.281,217.601 138.819,217.736 C140.358,217.87 141.496,219.226 141.361,220.764 C141.226,222.302 139.87,223.44 138.332,223.305 C136.794,223.171 135.656,221.815 135.791,220.277 z",
    fillOpacity: 0,
    stroke: "#979797",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "T/Deck"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-Copy-19"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.98,30.548 L958.864,30.548 C982.536,30.548 1001.726,48.456 1001.726,70.548 L1001.726,168.9 C1001.726,190.991 982.536,208.9 958.864,208.9 L55.98,208.9 C32.308,208.9 13.118,190.991 13.118,168.9 L13.118,70.548 C13.118,48.456 32.308,30.548 55.98,30.548 z",
    fill: "#EDEEF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.98,30.548 L958.864,30.548 C982.536,30.548 1001.726,48.456 1001.726,70.548 L1001.726,168.9 C1001.726,190.991 982.536,208.9 958.864,208.9 L55.98,208.9 C32.308,208.9 13.118,190.991 13.118,168.9 L13.118,70.548 C13.118,48.456 32.308,30.548 55.98,30.548 z",
    fillOpacity: 0,
    stroke: "#8993A4",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "T/Deck/Piping",
    opacity: 0.548
  }, /*#__PURE__*/React.createElement("path", {
    d: "M185.702,106.567 L977.981,106.567 C983.308,106.567 987.625,110.596 987.625,115.567 L987.625,119.495 C987.625,124.466 983.308,128.495 977.981,128.495 L185.702,128.495 C180.376,128.495 176.058,124.466 176.058,119.495 L176.058,115.567 C176.058,110.596 180.376,106.567 185.702,106.567 z",
    fillOpacity: 0,
    stroke: "#FFEE00",
    strokeWidth: 3,
    id: "Rectangle-Copy-27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.808,113.876 L974.309,113.876 C976.471,113.876 978.225,115.512 978.225,117.531 L978.225,117.531 C978.225,119.549 976.471,121.186 974.309,121.186 L187.808,121.186 C185.645,121.186 183.892,119.549 183.892,117.531 L183.892,117.531 C183.892,115.512 185.645,113.876 187.808,113.876 z",
    fillOpacity: 0,
    stroke: "#FFEE00",
    strokeWidth: 3,
    id: "Rectangle-Copy-28"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-Copy"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.002,50.552 L124.275,50.552 C125.459,50.552 126.418,51.448 126.418,52.552 L126.418,186.895 C126.418,188 125.459,188.895 124.275,188.895 L79.002,188.895 C77.819,188.895 76.859,188 76.859,186.895 L76.859,52.552 C76.859,51.448 77.819,50.552 79.002,50.552 z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.002,50.552 L124.275,50.552 C125.459,50.552 126.418,51.448 126.418,52.552 L126.418,186.895 C126.418,188 125.459,188.895 124.275,188.895 L79.002,188.895 C77.819,188.895 76.859,188 76.859,186.895 L76.859,52.552 C76.859,51.448 77.819,50.552 79.002,50.552 z",
    fillOpacity: 0,
    stroke: "#979797",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Polygon-Copy"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.001,15.421 C78.285,15.421 78.557,15.526 78.758,15.714 L78.758,15.714 L98.701,34.322 C98.902,34.509 99.014,34.764 99.014,35.029 L99.014,35.029 L99.014,61.344 C99.014,61.609 98.902,61.864 98.701,62.051 L98.701,62.051 L78.758,80.659 C78.557,80.847 78.285,80.952 78.001,80.952 L78.001,80.952 L49.798,80.952 C49.514,80.952 49.241,80.847 49.04,80.659 L49.04,80.659 L29.098,62.051 C28.897,61.864 28.784,61.609 28.784,61.344 L28.784,61.344 L28.784,35.029 C28.784,34.764 28.897,34.509 29.098,34.322 L29.098,34.322 L49.04,15.714 C49.241,15.526 49.514,15.421 49.798,15.421 L49.798,15.421 z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.001,15.421 C78.285,15.421 78.557,15.526 78.758,15.714 L78.758,15.714 L98.701,34.322 C98.902,34.509 99.014,34.764 99.014,35.029 L99.014,35.029 L99.014,61.344 C99.014,61.609 98.902,61.864 98.701,62.051 L98.701,62.051 L78.758,80.659 C78.557,80.847 78.285,80.952 78.001,80.952 L78.001,80.952 L49.798,80.952 C49.514,80.952 49.241,80.847 49.04,80.659 L49.04,80.659 L29.098,62.051 C28.897,61.864 28.784,61.609 28.784,61.344 L28.784,61.344 L28.784,35.029 C28.784,34.764 28.897,34.509 29.098,34.322 L29.098,34.322 L49.04,15.714 C49.241,15.526 49.514,15.421 49.798,15.421 L49.798,15.421 z",
    fillOpacity: 0,
    stroke: "#979797",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "T/hel"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.493,50.151 C55.397,50.061 55.35,49.961 55.354,49.849 C55.358,49.738 55.408,49.638 55.503,49.549 L64.802,40.87 C64.907,40.773 65.019,40.722 65.138,40.718 C65.258,40.715 65.366,40.758 65.462,40.848 L66.155,41.495 C66.261,41.593 66.314,41.701 66.315,41.817 C66.316,41.933 66.264,42.039 66.16,42.137 L62.201,45.832 L67.226,50.522 L71.185,46.827 C71.29,46.729 71.404,46.681 71.529,46.682 C71.653,46.683 71.763,46.728 71.859,46.818 L72.553,47.465 C72.658,47.564 72.712,47.671 72.713,47.787 C72.714,47.903 72.662,48.01 72.557,48.107 L63.258,56.786 C63.163,56.875 63.051,56.916 62.922,56.911 C62.792,56.906 62.68,56.858 62.583,56.768 L61.89,56.121 C61.794,56.032 61.745,55.929 61.745,55.813 C61.744,55.697 61.791,55.594 61.886,55.506 L65.987,51.678 L60.962,46.988 L56.86,50.816 C56.765,50.904 56.653,50.946 56.524,50.941 C56.395,50.935 56.282,50.888 56.186,50.798 L55.493,50.151 z",
    fill: "#2F2F2F",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.183,58.29 C68.58,63.518 59.496,63.517 53.893,58.288 C48.29,53.059 48.289,44.582 53.891,39.353 C59.494,34.125 68.578,34.125 74.181,39.355 C79.785,44.584 79.785,53.061 74.183,58.29 z",
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    id: "Oval"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Path-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M942.736,21.711 C982.063,25.52 1001.726,41.981 1001.726,71.094 C1001.726,114.763 1001.726,132.253 1001.726,175.186 C1001.726,203.808 983.938,219.983 948.361,223.711 L948.361,195.89 L958.342,183.597 L958.342,156.201 L963.816,146.82 L963.816,99.496 L958.342,90.114 L958.342,60.348 L948.361,48.697 L948.361,30.269 L942.736,30.269 L942.736,21.711 z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M942.736,21.711 C982.063,25.52 1001.726,41.981 1001.726,71.094 C1001.726,114.763 1001.726,132.253 1001.726,175.186 C1001.726,203.808 983.938,219.983 948.361,223.711 L948.361,195.89 L958.342,183.597 L958.342,156.201 L963.816,146.82 L963.816,99.496 L958.342,90.114 L958.342,60.348 L948.361,48.697 L948.361,30.269 L942.736,30.269 L942.736,21.711 z",
    fillOpacity: 0,
    stroke: "#979797",
    strokeWidth: 1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeck11);
export default __webpack_public_path__ + "static/media/deck11.d7537b2f.svg";
export { ForwardRef as ReactComponent };